import { Product, Team } from 'teams';

export const SHOW_INSIGHTS_DRAWER_CALLBACK_KEY = 'showAudienceInsightsDrawer';
export const SHOW_CATALOG_QUERY_DRAWER_CALLBACK_KEY = 'showCatalogQueryDrawer';
export const SEGMENTATION_ERROR_TOAST_KEY = 'segmentationErrorToastKey';

export const AUDIENCE_INSIGHTS_DRAWER_EXPANSION_KEY = 'audience-insights-drawer';
export const CATALOG_QUERY_DRAWER_EXPANSION_KEY = 'catalog-query-drawer';

export const USER_INSIGHTS_RUM_ATTRIBUTES = {
  teamName: Team.AUDIENCE_TEAM,
  productName: Product.AUDIENCE_INSIGHTS,
};
